module.exports = __webpack_public_path__ + "static/media/MyProject.5f405cb4.png";